<div>
  <button
    *ngIf="mostrar"
    mat-fab
    color="primary"
    (click)="volver()"
    aria-label="Volver atrás"
    class="btn-back"
  >
    <mat-icon>arrow_back</mat-icon>
    <p>Volver atrás</p>
  </button>
</div>
